import { AGENT_TRACKER_ROLE } from "vue-app/types/enums";

export const settingsRoutes = [
  {
    path: "/app/settings",
    redirect: "/app/settings/agents",
    meta: {
      requiredRoles: [AGENT_TRACKER_ROLE.ROLE_AGENT],
    },
  },
  {
    path: "/app/settings/agents",
    component: () => import("./agents/AgentsPage"),
    meta: {
      routeName: window.$_t("SETTINGS"),
      requiredRoles: [AGENT_TRACKER_ROLE.ROLE_SETTINGS],
      skipGlobalLoader: true,
    },
  },
  {
    path: "/settings/stripeSuccessCallback",
    redirect: "/app/settings/stripeSuccessCallback",
  },
  {
    path: "/app/settings/stripeSuccessCallback",
    component: () => import("../twig/TwigPageContainer"),
    meta: {
      routeName: window.$_t("SETTINGS"),
      legacyHref: "/settings/stripeSuccessCallback",
      legacyLayout: true,
      requiredRoles: [AGENT_TRACKER_ROLE.ROLE_SETTINGS],
    },
  },
  {
    path: "/settings/stripeErrorCallback",
    redirect: "/app/settings/stripeErrorCallback",
  },
  {
    path: "/app/settings/stripeErrorCallback",
    component: () => import("../twig/TwigPageContainer"),
    meta: {
      routeName: window.$_t("SETTINGS"),
      legacyHref: "/settings/stripeErrorCallback",
      legacyLayout: true,
      requiredRoles: [AGENT_TRACKER_ROLE.ROLE_SETTINGS],
    },
  },
  {
    path: "/app/settings/partner",
    component: () => import("../twig/TwigPageContainer"),
    meta: {
      routeName: window.$_t("SETTINGS"),
      legacyHref: "/partner",
      legacyLayout: true,
      requiredRoles: [AGENT_TRACKER_ROLE.ROLE_SETTINGS],
    },
  },
  {
    path: "/app/settings/sending-domain",
    name: "PageSendingDomain",
    component: () => import("vue-app/pages/PageSendingDomain/PageSendingDomain.vue"),
    meta: {
      routeName: window.$_t("SENDING DOMAIN"),
      noPadding: true,
      requiredRoles: [AGENT_TRACKER_ROLE.ROLE_SETTINGS],
      skipGlobalLoader: true,
    },
  },
  {
    path: "/app/export",
    component: () => import("vue-app/pages/PageExport/PageExport.vue"),
    meta: {
      routeName: window.$_t("EXPORT"),
      requiredRoles: [AGENT_TRACKER_ROLE.ROLE_DB],
      noPadding: true,
      skipGlobalLoader: true,
    },
  },
  {
    path: "/app/import",
    component: () => import("../../../../vue-app/components/Import/ImportHistory/ImportHistory.vue"),
    meta: {
      routeName: window.$_t("IMPORT"),
      requiredRoles: [AGENT_TRACKER_ROLE.ROLE_DB],
      noPadding: true,
    },
  },
  {
    path: "/app/import/v2",
    component: () => import("./import-v2/import-wizard/ImportWizard"),
    meta: {
      routeName: window.$_t("IMPORT"),
      requiredRoles: [AGENT_TRACKER_ROLE.ROLE_DB],
      skipGlobalLoader: true,
    },
    children: [
      {
        name: "import-actions",
        path: "actions",
        component: () => import("./import-v2/import-wizard/pages/ImportActions"),
        meta: {
          skipGlobalLoader: true,
          routeName: window.$_t("IMPORT"),
          requiredRoles: [AGENT_TRACKER_ROLE.ROLE_DB],
        },
      },
      {
        name: "import-upload",
        path: "upload",
        component: () => import("./import-v2/import-wizard/pages/ImportFileUpload"),
        meta: {
          skipGlobalLoader: true,
          routeName: window.$_t("IMPORT"),
          requiredRoles: [AGENT_TRACKER_ROLE.ROLE_DB],
        },
      },
      {
        name: "import-mapping",
        path: "mapping",
        component: () => import("./import-v2/import-wizard/pages/ImportMapping"),
        meta: {
          skipGlobalLoader: true,
          routeName: window.$_t("IMPORT"),
          requiredRoles: [AGENT_TRACKER_ROLE.ROLE_DB],
        },
      },
      {
        name: "import-tags",
        path: "tags",
        component: () => import("./import-v2/import-wizard/pages/ImportTags"),
        meta: {
          skipGlobalLoader: true,
          routeName: window.$_t("IMPORT"),
          requiredRoles: [AGENT_TRACKER_ROLE.ROLE_DB],
        },
      },
      {
        name: "import-summary",
        path: "summary",
        component: () => import("./import-v2/import-wizard/pages/ImportSummary"),
        meta: {
          skipGlobalLoader: true,
          routeName: window.$_t("IMPORT"),
          requiredRoles: [AGENT_TRACKER_ROLE.ROLE_DB],
        },
      },
    ],
  },
  {
    path: "/app/settings/product-feed-import",
    redirect: "/app/products",
  },
  {
    path: "/app/settings/branding",
    component: () => import("../../../../vue-app/pages/PageBranding/PageBranding.vue"),
    meta: {
      routeName: window.$_t("SETTINGS"),
      noPadding: true,
      skipGlobalLoader: true,
    },
  },
  {
    path: "/app/integrations",
    component: () => import("../../../../vue-app/pages/PageIntegrations.vue"),
    meta: {
      routeName: window.$_t("INTEGRATIONS"),
      requiredRoles: [AGENT_TRACKER_ROLE.ROLE_SETTINGS],
      noPadding: true,
      skipGlobalLoader: true,
    },
    redirect: "/app/integrations",
    children: [
      {
        path: "/app/integrations",
        component: () => import("../../../../vue-app/pages/PageIntegrationPlatforms.vue"),
        meta: {
          routeName: window.$_t("INTEGRATION"),
          requiredRoles: [AGENT_TRACKER_ROLE.ROLE_SETTINGS],
          noPadding: true,
          skipGlobalLoader: true,
        },
      },
      {
        path: "/app/integrations/allegro",
        component: () => import("../../../../vue-app/pages/PageIntegrationAllegro/PageIntegrationAllegro.vue"),
        meta: {
          routeName: window.$_t("INTEGRATION"),
          noPadding: true,
        },
      },
      {
        path: "/app/integrations/whatsapp",
        component: () => import("../../../../vue-app/pages/PageIntegrationWhatsapp.vue"),
        meta: {
          routeName: window.$_t("INTEGRATION"),
          noPadding: true,
        },
      },
      {
        path: "/app/integrations/messenger",
        component: () => import("../../../../vue-app/pages/PageIntegrationMessenger.vue"),
        meta: {
          noPadding: true,
          routeName: window.$_t("INTEGRATION"),
          requiredRoles: [AGENT_TRACKER_ROLE.ROLE_SETTINGS],
        },
      },
      {
        path: "/app/integrations/google-analytics",
        component: () => import("../../../../vue-app/pages/PageGoogleAnalytics.vue"),
        meta: {
          noPadding: true,
          routeName: window.$_t("INTEGRATION"),
          requiredRoles: [AGENT_TRACKER_ROLE.ROLE_SETTINGS],
          skipGlobalLoader: true,
        },
      },
      {
        path: "/app/integrations/communicators",
        component: () => import("../../../../vue-app/pages/PageCommunicators.vue"),
        meta: {
          routeName: window.$_t("INTEGRATION"),
          legacyHref: "/facebook-messenger",
          legacyLayout: true,
          requiredRoles: [AGENT_TRACKER_ROLE.ROLE_SETTINGS],
          skipGlobalLoader: true,
        },
      },
      {
        path: "/app/integrations/communicators",
        component: () => import("../../../../vue-app/pages/PageCommunicators.vue"),
        meta: {
          routeName: window.$_t("INTEGRATION"),
          legacyHref: "/settings/smsapi",
          legacyLayout: true,
          requiredRoles: [AGENT_TRACKER_ROLE.ROLE_SETTINGS],
          skipGlobalLoader: true,
        },
      },
      {
        path: "/app/integrations/landing-pages",
        component: () => import("../../../../vue-app/pages/PageLandingPages.vue"),
        meta: {
          routeName: window.$_t("Landing Pages"),
          noPadding: true,
          backgroundColor: "#ffffff",
          skipGlobalLoader: true,
        },
      },
    ],
  },
  {
    path: "/app/settings/cancellation",
    name: "PageCancellation",
    component: () => import("vue-app/pages/PageCancellation.vue"),
    meta: {
      routeName: window.$_t("SETTINGS"),
      noPadding: true,
      skipGlobalLoader: true,
      requiredRoles: [AGENT_TRACKER_ROLE.ROLE_AGENT],
    },
  },
];
